//./plugins/posthog.js
import posthog from "posthog-js";
import { App } from "vue";

const posthogKey = import.meta.env.VITE_POSTHOG_TOKEN;
const posthogInstanceAddress = import.meta.env.VITE_POSTHOG_INSTANCE_ADDRESS;

export default {
	install(app: App) {
		if (posthogKey && posthogInstanceAddress) {
			const hashParams = new URLSearchParams(window.location.hash.substring(1));
			const sessionId = hashParams.get("sessionId");
			const distinctId = hashParams.get("distinctId");
			const bootstrapConfig: { sessionID?: string; distinctID?: string } = {};
			if (sessionId) {
				bootstrapConfig.sessionID = sessionId;
			}
			if (distinctId) {
				bootstrapConfig.distinctID = distinctId;
			}

			app.config.globalProperties.$posthog = posthog.init(posthogKey, {
				api_host: posthogInstanceAddress,
				...(Object.keys(bootstrapConfig).length > 0 && { bootstrap: bootstrapConfig }),
				autocapture: {
					dom_event_allowlist: ["click", "submit"], // DOM events from this list ['click', 'change', 'submit']
					element_allowlist: ["button"], // DOM elements from this list ['a', 'button', 'form', 'input', 'select', 'textarea', 'label']
				},
				// @ts-ignore - PostHog types don't include rageclick config object, but it's supported
				rageclick: {
					click_count: 5, // Require 5+ clicks instead of 3
					timeout_ms: 1500, // Within 1.5 seconds instead of 1
					threshold_px: 100, // Can move 100px between clicks
					// css_selector_ignorelist: ['.calendar-button']
				},
			});
		}
	},
};
